export default class {
    constructor() {

    }

    setBackground(shape, color) {
        shape.setOptions({ fillColor: color });
    }

    setBorder(shape, color) {
        shape.setOptions({ strokeColor: color, oldStrokeColor: shape.strokeColor });
    }

    resetBorder(shape) {
        shape.setOptions({ strokeColor: shape.oldStrokeColor, oldStrokeColor: null });
    }

    setMetaData(shape, metaData) {
        shape.setOptions({ meta: metaData });
    }

    setOptions(shape, options) {
        shape.setOptions(options);
    }

    enableEditing(shape) {
        this.setOptions(shape, {
            editable: true,
        });
    }

    disableEditing(shape) {
        this.setOptions(shape, {
            editable: false,
        });
    }
}